import React from 'react';
import Customer from '../../../../assets/Features.png';
import Logo1 from '../../../../assets/features/5.png';
import Logo2 from '../../../../assets/features/6.png';
import Logo3 from '../../../../assets/features/12.png';
import Logo4 from '../../../../assets/features/13.png';

import './CustomerSection.css';

const CustomerSection = () => {
    return (
        <div className="container customer__container row justify-content-between align-items-center shadow-lg">
            <div className="col-md-5">
                <img src={Customer} alt="customer" className='w-100 h-75'/>
            </div>
            <div className="col-md-6 p-5">
                <h3 className="customer__heading">
                    Customer support is our main priority with their hundred percent satisfaction.
                </h3>
                <p className="customer__para">
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. 
                    Quaerat ipsa consequuntur tempora ea quos cum vero soluta nulla eum non.
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi itaque iure excepturi nesciunt quos cumque.
                </p>
                <div className="row gap-4">
                    <div className="col-md-6 row">
                        <div className="col-md-3">
                            <img src={Logo1} alt="" style={{width: "3rem", height: "3rem"}}/>
                        </div>
                        <div className="col-md-9">
                            <strong className="mx-4">Portfolio</strong>
                        </div>                    
                    </div>
                    <div className="col-md-6 row">
                        <div className="col-3">
                            <img src={Logo2} alt="" style={{width: "3rem", height: "3rem"}}/>
                        </div>
                        <div className="col-9">
                             <strong className="mx-4">Portfolio</strong>
                        </div>
                    </div>
                    <div className="col-md-6 row">
                       <div className="col-3">
                            <img src={Logo3} alt="" style={{width: "3rem", height: "3rem"}}/>
                       </div>
                       <div className="col-9">
                            <strong className="mx-4">Portfolio</strong>
                        </div> 
                    </div>
                    <div className="col-md-6 row">
                        <div className="col-3">
                            <img src={Logo4} alt="" style={{width: "3rem", height: "3rem"}}/>
                        </div>
                        <div className="col-9">
                            <strong className="mx-4">Portfolio</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerSection
